export interface User {
    id?:number;
    username: string;
    password: string;
    token?: string;
    role: Role;
}


export enum Role{
    SuperAdmin = '1',
    OrganizationAdmin = '2',
    User = '3',
    UserReport = '4',
}

export enum RoleName{
    SuperAdmin = 'Super Admin',
    OrganizationAdmin = 'Organization Admin',
    User = 'Employee',
    UserReport = 'User Report',
}

export interface IBreadCrumb {
label: string;
url: string;
}